import { CatIconWarningCircle } from '@blocks-react/components/Icons/WarningCircle';
import { CatHeading } from '@blocks-react/components/Heading';
import { ErrorBanner } from '../../common/error-banner';

type ErrorBannerProps = {
  content: string;
};

export const MyEquipmentErrorBanner = ({ content }: ErrorBannerProps) => {
  return (
    <ErrorBanner heading="" variant="error">
      <CatIconWarningCircle slot="before" color="content-strong" />
      <CatHeading variant="label">{content}</CatHeading>
    </ErrorBanner>
  );
};
